import { VueModule } from '@Foundation/utilities';
import hubVideo from './code/Scripts/components/hub-video';

export default VueModule({
  components: {
    hubVideo
  }
});
